// extracted by mini-css-extract-plugin
export default {"upper":"S01_upper__YnO15","info":"S01_info__LWnIO","text":"S01_text__3oYuh","bottom":"S01_bottom__xEpdV","videoContainer":"S01_videoContainer__IlfH6"};